/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import * as THREE from 'three'
import React, { useImperativeHandle, useRef } from 'react'
import { PerspectiveCamera, useAnimations, useGLTF } from '@react-three/drei'
import { GenericGLTFResult } from '../../types/GenericGLTFResult'
import { useMoveStore } from '../../store/moveStore'

type GLTFResult = GenericGLTFResult & {
  nodes: {
    dbl_door_1: THREE.Mesh
    dbl_door_2: THREE.Mesh
    Door: THREE.Mesh
    Door1: THREE.Mesh
    Door2: THREE.Mesh
    Door3: THREE.Mesh
    Door4: THREE.Mesh
    Door5: THREE.Mesh
    Door6: THREE.Mesh
    Doors_double: THREE.Mesh
    Lamp: THREE.Mesh
    Lamp2: THREE.Mesh
    Lamp3: THREE.Mesh
    walls: THREE.Mesh
    walls1: THREE.Mesh
  }
  materials: {
    StingrayPBS4: THREE.MeshStandardMaterial
  }
}

export const Corridor = React.forwardRef((props: JSX.IntrinsicElements['group'], ref) => {
  const { nodes, materials, animations } = useGLTF('/gltfs/Corridor/Corridor.gltf') as GLTFResult
  const group = useRef<THREE.Group>()

  const { actions } = useAnimations(animations, group)

  useImperativeHandle(ref, () => ({
    traverse: (callback: (object: THREE.Object3D<THREE.Event>) => any) => {
      if (group.current) group.current.traverse(callback)
    },
    playAnimation: (animationName: string) => {
      if (actions && actions[animationName]) {
        const action = actions[animationName]
        if (action) {
          for (const a in actions) if (a !== animationName) actions[a]?.stop()

          action.repetitions = 1
          action.clampWhenFinished = true
          useMoveStore.getState().lockMovement()
          action.reset().play()
          setTimeout(() => {
            useMoveStore.getState().unlockMovement()
          }, (action.getClip().duration * 1000))
          return true
        }
        return false
      }
    }
  }), [])

  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Scene">
        <group name="corrdor_geo_GRP">
          <mesh name="dbl_door_1"
                castShadow
                receiveShadow
                geometry={nodes.dbl_door_1.geometry}
                material={materials.StingrayPBS4} />
          <mesh name="dbl_door_2"
                castShadow
                receiveShadow
                geometry={nodes.dbl_door_2.geometry}
                material={materials.StingrayPBS4} />
          <mesh name="Door"
                castShadow
                receiveShadow
                geometry={nodes.Door.geometry}
                material={materials.StingrayPBS4} />
          <mesh name="Door1"
                castShadow
                receiveShadow
                geometry={nodes.Door1.geometry}
                material={materials.StingrayPBS4}
                position={[5.1, 0, 0]} />
          <mesh name="Door2"
                castShadow
                receiveShadow
                geometry={nodes.Door2.geometry}
                material={materials.StingrayPBS4}
                position={[11.5, 0, 1.7]}
                rotation={[0, -0.19, 0]} />
          <mesh name="Door3"
                castShadow
                receiveShadow
                geometry={nodes.Door3.geometry}
                material={materials.StingrayPBS4}
                position={[15.31, 0, 0]} />
          <mesh name="Door4"
                castShadow
                receiveShadow
                geometry={nodes.Door4.geometry}
                material={materials.StingrayPBS4}
                position={[-3.2, 0, 12.18]}
                rotation={[Math.PI, 0, Math.PI]} />
          <mesh name="Door5"
                castShadow
                receiveShadow
                geometry={nodes.Door5.geometry}
                material={materials.StingrayPBS4}
                position={[-8.29, 0, 12.18]}
                rotation={[Math.PI, 0, Math.PI]} />
          <mesh name="Door6"
                castShadow
                receiveShadow
                geometry={nodes.Door6.geometry}
                material={materials.StingrayPBS4}
                position={[-13.41, 0, 12.18]}
                rotation={[Math.PI, 0, Math.PI]} />
          <mesh name="Doors_double"
                castShadow
                receiveShadow
                geometry={nodes.Doors_double.geometry}
                material={materials.StingrayPBS4}
                position={[-0.67, 0, 12.1]}
                rotation={[Math.PI, 0, Math.PI]} />
          <mesh name="Lamp"
                castShadow
                receiveShadow
                geometry={nodes.Lamp.geometry}
                material={materials.StingrayPBS4} />
          <mesh name="Lamp2"
                castShadow
                receiveShadow
                geometry={nodes.Lamp2.geometry}
                material={materials.StingrayPBS4}
                position={[15.44, 0, 0]} />
          <mesh name="Lamp3"
                castShadow
                receiveShadow
                geometry={nodes.Lamp3.geometry}
                material={materials.StingrayPBS4} />
          <mesh name="walls"
                castShadow
                receiveShadow
                geometry={nodes.walls.geometry}
                material={materials.StingrayPBS4} />
          <mesh name="walls1"
                castShadow
                receiveShadow
                geometry={nodes.walls1.geometry}
                material={materials.StingrayPBS4}
                position={[-20.55, 0, 0]} />
        </group>
        <PerspectiveCamera name="CAM"
                           makeDefault={false}
                           far={1000000}
                           near={0.05}
                           fov={46.4}
                           position={[-13.12, 1.5, 6.04]}
                           rotation={[0, -Math.PI / 2, 0]}
                           scale={5} />
      </group>
    </group>
  )
})
Corridor.displayName = 'Corridor'
export default Corridor

useGLTF.preload('/gltfs/Corridor/Corridor.gltf')
